// collections
export const USERS = "users";
export const EVENTS = "events";
export const BETS = "bets";
export const ANSWERS = "answers";
